export default "__VITE_ASSET__B6fg4QS4__"